import React, { useRef } from 'react'
import YouTube, { YouTubeEvent } from 'react-youtube'
import { VideoNode } from '../../types/nodeTypes'
import SkipButton from '../buttons/SkipButton'

type VideoNodeProps = {
  node: VideoNode
  onVideoEnded?: () => void
}

const Video: React.FC<VideoNodeProps> = ({ node, onVideoEnded }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)

  const videoId = ((): string | null => {
    try {
      const url = new URL(node.videoUrl)

      if (url.hostname.includes('youtube.com') && url.searchParams.has('v')) {
        return url.searchParams.get('v')
      }

      if (url.hostname.includes('youtu.be')) {
        return url.pathname.substring(1)
      }

      return null
    } catch (e) {
      console.log('An error occured on Video', e)
      return null
    }
  })()

  const handleEnded = (): void => {
    if (onVideoEnded !== undefined) onVideoEnded()
  }

  const handleStateChange = (event: YouTubeEvent): void => {
    if (event.data === 0) {
      handleEnded()
    }
  }

  return (
    <div className="layout-node">
      <div className={`image-layout`}>
        {node.videoUrl.endsWith('.mp4') ? (
          <video
            ref={videoRef}
            className="full-content-box"
            controls
            autoPlay
            playsInline
            onEnded={handleEnded}
            src={node.videoUrl}
          />
        ) : (
          <YouTube
            className="vocads-widget-video-wrapper"
            videoId={videoId}
            onStateChange={handleStateChange}
            opts={{ playerVars: { autoplay: 1 }, width: '100%', height: '100%' }}
          />
        )}
      </div>
      <div className="skip-button-layout">
        <SkipButton onClick={handleEnded} />
      </div>
    </div>
  )
}

export default Video
